import StatisticWithLabelAndCount from './StatisticWithLabelAndCount';

export default StatisticWithLabelAndCount;